<template>
    <div class="content">
        <el-carousel :interval="5000" arrow="hover" trigger="click" height="calc(100vh - var(--head-height))">
            <el-carousel-item v-for="(src,index) in img" :key="index">
                <img :src="src" />
            </el-carousel-item>
        </el-carousel>
    </div>
</template>
<script>
export default {
    data(){
        return{
            img:dataconfig.home.img
        }
    }
}
</script>
<style scoped>
    .content{
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
    img{
        width: 100%;
        height: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/view/page/home.vue